module.exports = __webpack_public_path__ + "static/leg_crossing_hardware_3frames-33fbbc76e2b4718907b0cfaba075bbc8.png";